import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, partnersService } from '@v2/services';
import type { CreatePartnerPayload } from '@v2/types';

export const useCreatePartner = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: partnersService.createPartner,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.partners.all);
    },
  });

  const createPartner = async (
    payload: CreatePartnerPayload
  ): Promise<string | null> => {
    try {
      return await mutation.mutateAsync(payload);
    } catch {
      return null;
    }
  };

  return {
    createPartner,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreatePartner;
